import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLatestStatus } from 'utils/formatters/shipments';
import { getShipmentDetailUrl } from '../../../../utils/formatters/shipments';
class DriverJobRow extends Component {
    getStatus() {
        const latestStatus = getLatestStatus(this.props.job);
        return latestStatus.status.message;
    }
    render() {
        const { job, } = this.props;
        const { shipment_id, _id } = job;
        const origin = job.origin[0];
        let originName = '';
        let originZipCode = '';
        if (origin) {
            originName = origin.name;
            originZipCode = origin.zipcode;
        }
        let destinationName = '';
        let destinationZipCode;
        const destination = job.destination[0];
        if (destination) {
            destinationName = destination.name;
            destinationZipCode = destination.zipcode;
        }
        const shipmentDetailLink = getShipmentDetailUrl(_id);
        return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("a", { href: shipmentDetailLink }, shipment_id)),
            React.createElement("td", null,
                originName,
                "(",
                originZipCode,
                ")"),
            React.createElement("td", null,
                destinationName,
                "(",
                destinationZipCode,
                ")"),
            React.createElement("td", null, this.getStatus())));
    }
}
DriverJobRow.propTypes = {
    job: PropTypes.object.isRequired,
};
export default DriverJobRow;
